import {CurrencyPipe, DatePipe, DecimalPipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
@Pipe({name: 'formatCell'})
export class FormatCellPipe implements PipeTransform {
  constructor(
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
  ) {}
  transform(value: any, defs: any) {
    if (value === undefined || value === null) {
      return '';
    }
    let format = defs && defs['format'] ? defs['format'] : 'S';

    if (format === 'T') {
      return this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss');
    } else if (format === 'D') {
      return this.datePipe.transform(value, 'dd/MM/yyyy');
    } else if (format === 'I') {
      //return this.decimalPipe.transform(value, '1.0-0');
      return value;
    } else if (format === 'N') {
      //return this.currencyPipe.transform(value, 'USD', true);
      return this.decimalPipe.transform(value, '1.2-2');
    } else if (format === 'O') {
      if (Array.isArray(value)) {
        if (typeof value[0] !== 'object') {
          return value.join(', ');
        } else {
          return value
            .map((obj) => {
              return obj.name;
            })
            .join(', ');
        }
      }
      if (typeof value === 'object') {
        return value.name;
      }
    } else if (format === 'L') {
      let lkpCellRender = JSON.parse(
        localStorage.getItem('lkpCellRender' + localStorage.getItem('langId')),
      );
      //search in lookup
      return lkpCellRender[defs.lkpTable][defs.lkpCol][value] != null &&
        lkpCellRender[defs.lkpTable][defs.lkpCol][value] != ''
        ? lkpCellRender[defs.lkpTable][defs.lkpCol][value]
        : value;
    } else if (format === 'H') {
      let lkpCellRender = JSON.parse(
        localStorage.getItem('lkpCellRender' + localStorage.getItem('langId')),
      );
      //search in lookup
      return lkpCellRender[defs.lkpTable][defs.lkpCol][value] != null &&
        lkpCellRender[defs.lkpTable][defs.lkpCol][value] != ''
        ? lkpCellRender[defs.lkpTable][defs.lkpCol][value]
        : value;
    } else {
      // format == 'S' / ''
      return value;
    }
  }
}
